<template>
  <div>
    <vue-dropzone
      class="dropzone-module-small w-25"
      ref="tincanDropzone2"
      id="dropzone_lesson_list"
      :key="`${selected_language.key}`"
      :options="dropzoneOptions"
      :url="dropzoneOptions.url"
      @vdropzone-error="dropzoneFail"
      @vdropzone-success="attachmentUploaded"
    >
    </vue-dropzone>

  </div>
</template>
<script>
export default {
  props: {
    selected_language: {
      required: false,
      default: "EN",
    },
	lesson:{
		required: true
	},
	temp_url_tincan:{
		required: true
	},
	index:{
		required: true
	}
  },
  data: () => {
    return {
	file_types:['Tincan','Rise'],
      dropzoneOptions: {
        url: null,
        thumbnailWidth: 50,
        maxFilesize: 500,
        maxFiles: 1,
        timeout: 300000,
        addRemoveLinks: true,
        headers: {
          Autrollization: localStorage.getItem("token"),
        },
      },
    };
  },
  created : function(){
	  this.setTincan(this.selected_language)
	  if(this.lesson){
		  this.current_lesson = this.lesson
	  }
  },
  methods: {
    dropzoneFail: function (_file, _message, xhr) {
      const elements = document.querySelectorAll(".dz-error-message span");
      const lastElement = elements[elements.length - 1];
      lastElement.textContent = _message.error_message || "Server Error.";
    },
    attachmentUploaded: function (file, response) {
		console.log('response', response)
      //when we come here, make the v-select mandatory
      this.lesson_file_type = "";
      //here lets refresh the lessons
      this.current_lesson.has_tincan[this.selected_language.key] = true;
      this.current_lesson.image[this.selected_language.key] =
        response.lesson.image[this.selected_language.key];
      this.current_lesson.tincan_thumbnail[this.selected_language.key] =
        response.lesson.tincan_thumbnail[this.selected_language.key];
      this.current_lesson.tincan_url[this.selected_language.key] =
        response.lesson.tincan_url[this.selected_language.key];
      this.current_lesson.tincan_download_url[this.selected_language.key] =
        response.lesson.tincan_download_url[this.selected_language.key];
		  this.$emit('updateLessonTincan', this.current_lesson, this.index)

      if (response.warnings.length > 0) {
        this.$snotify.setDefaults({
          toast: {
            timeout: 0,
          },
        });
        response.warnings.forEach(warning => this.$snotify.warning(warning));
        this.$snotify.setDefaults({
          toast: {
            timeout: 10000,
          },
        });
      }
    },
	setTincan:function(){
		this.dropzoneOptions.url = this.temp_url_tincan+'/'+this.selected_language.key
		if(this.$refs.tincanDropzone2){
			for(let i in this.$refs.tincanDropzone2){
				this.$refs.tincanDropzone[i].dropzone.options.url =  this.dropzoneOptions.url
			}
		}
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sme/SharedViews/LessonDropZone.vue